// refundInitiationMutationSlice.js
import { apiSlice } from "../apiSlice";

export const refundInitiationMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    patchRefundInitiationStatus: builder.mutation({
      query: ({ id, status, remarks }) => ({
        url: `refund_payments/${id}`,
        method: "PATCH",
        body: { shipment_id: id, status, remarks },
      }),

      async onQueryStarted(
        { id, status, remarks, filters },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedRefundInitiation } = await queryFulfilled;

          // ✅ update normalized cache from refundInitiationList
          dispatch(
            apiSlice.util.updateQueryData(
              "getRefundInitiationList",        // aligned endpoint
              filters || {},
              (draft) => {
                const existing = draft.entities[id];
                if (existing) {
                  Object.assign(existing, updatedRefundInitiation);
                }
              }
            )
          );
        } catch (e) {
          console.error("Refund initiation update failed:", e);
        }
      },

      invalidatesTags: (result, error, { id }) => [
        { type: "refundInitiation", id },
        { type: "refundInitiation", id: "LIST" },
      ],
    }),
  }),
});

export const {
  usePatchRefundInitiationStatusMutation,
} = refundInitiationMutationApiSlice;
